// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__XKCSb","onlyLogoFixed":"styles_onlyLogoFixed__egM5z","searchMobile":"styles_searchMobile__V3uzp","navigation":"styles_navigation__p0FmI"};